export const createMonzoLink = (amount: string, description: string): string => {
  const baseUrl = 'https://monzo.me/richvaughan8';
  const priceWithoutSymbol = amount.replace('£', '');
  const encodedDescription = encodeURIComponent(description);

  return `${baseUrl}/${priceWithoutSymbol}?h=iSIWPJ&d=${encodedDescription}`;
};